import React, { useContext } from 'react';
import { isEmpty } from 'underscore';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const formatTargets = ({ data, includedData, excludedData, i18n, singularText, pluralText }) => {
  if ((!data || !data.length) && (isEmpty(includedData) && isEmpty(excludedData))) {
    return i18n.getString(_TL_('Targeting: No {{singularText}} segments selected.'), { singularText });
  }

  const targetedCriterions = includedData || data.filter(({ Status }) => Status === 'Active');
  const excludedCriterions = excludedData || data.filter(({ Status }) => Status === 'Excluded');

  let targetedCriterionDetails = '';
  let excludedCriterionDetails = '';

  if (targetedCriterions.length === 1) {
    targetedCriterionDetails = i18n.getString(_TL_('Targeted: 1 {{singularText}}'), { singularText });
  } else if (targetedCriterions.length > 1) {
    targetedCriterionDetails = i18n.getString(_TL_('Targeted: {{count}} {{pluralText}}'), { count: (targetedCriterions.length), pluralText });
  }

  if (excludedCriterions.length === 1) {
    excludedCriterionDetails = i18n.getString(_TL_('Excluded: 1 {{singularText}}'), { singularText });
  } else if (excludedCriterions.length > 1) {
    excludedCriterionDetails = i18n.getString(_TL_('Excluded: {{count}} {{pluralText}}'), { count: (excludedCriterions.length), pluralText });
  }

  return `${targetedCriterionDetails}${targetedCriterionDetails && excludedCriterionDetails && '. '}${excludedCriterionDetails}`;
};

export const CommonTarget = ({ data, label, singularText, pluralText, includedData, excludedData }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label }}>
      <Text>{formatTargets({ data, i18n, singularText, pluralText, includedData, excludedData })}</Text>
    </PropertyRow>
  );
};

CommonTarget.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  label: PropTypes.string,
  includedData: PropTypes.arrayOf(PropTypes.shape({})),
  excludedData: PropTypes.arrayOf(PropTypes.shape({})),
  singularText: PropTypes.string,
  pluralText: PropTypes.string,
};

CommonTarget.defaultProps = {
  data: [],
  label: '',
  includedData: null,
  excludedData: null,
  singularText: '',
  pluralText: '',
};
